module.exports = {
    'es': {
        // overview
        // start ======
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penalti rechazado',
        'ownGoal': 'Gol en propia puerta',
        'assist': 'Asistencia',
        'statistics': 'Estadística',
        'noData': 'Sin datos',
        'notPrepared': 'Partido no se inicia',
        // ======= end
        'prediction': 'Apoya a tu equipo',
        'vote': 'Votar',
        'voted': 'Votado',
        'home': 'Casa',
        'draw': 'Empate',
        'away': 'Fuera',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'El voto falló, reintenta ~',
        'matchVoted': 'Ya has votado ~',
        'matchNotStart': 'La partida no comienza',
        'predictionEnd': 'La predicción es final, recuerda predecir antes del partido',
        'broadcast': 'Información de transmisión',
        'statistic': 'Estadísticas de Jugador',
        'past_games': 'Partidos Pasados',
        'pg_no': 'No partidos pasados',
        'pg_lng': 'Últimos Partidos',
        'pg_w': '{count} PG',
        'pg_d': '{count} PE',
        'pg_date': 'Fecha',
        'pg_competition': 'Competición',
        'pg_home': 'Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fuera',
        'absentee': 'Ausente',
        'absentee_no': 'No hay ausente',
        'recent_games': 'Partidos Recientes',
        'rg_no': 'No hay partidos recientes',
        'rg_date': 'Fecha',
        'rg_competition': 'Competición',
        'rg_home': 'Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fuera',
        'league_table': 'Tabla de la liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Casa',
        'lt_away': 'Fuera',
        'lt_p': 'PJ',
        'lt_w': 'PG',
        'lt_d': 'PE',
        'lt_l': 'PP',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'PT',
        'lt_rank': 'Rango',
        'lt_wp': 'Porcentaje de victorias',
        'ct_team': 'Equipo',
        'ct_p': 'PJ',
        'ct_w': 'PG',
        'ct_d': 'PE',
        'ct_l': 'PP',
        'ct_fa': '+/-',
        'ct_pts': 'PT',
        'odds': 'Cuotas',
        'odds_no': 'No hay cuotas',
        'odds_no_data': 'Sin datos',
        'odds_handicap': 'Desventaja',
        'odds_ou': 'Más/Menos',
        'odds_1x2': '1x2',
        'odds_over': 'Más',
        'odds_under': 'Menos',
        'odds_total': 'Total',
        'odds_more': ' Más',
        'odds_company': 'Empresa',
        'odds_type': 'Tipo',
        'odds_spot': 'Lugar',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fuera',
        'odds_tu': 'Actualización',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fuera',
        'odds_highest': 'Máximo',
        'odds_lowest': 'Mínimo',
        'odds_average': 'Promedio',
        'odds_changes': 'La probabilidad cambia',
        'odds_dc': 'El detalle cambia',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fraccional',
        'more': 'Más'
    },
    'pt': {
        // overview
        // start ======
        'events': 'Eventos',
        'goal': 'Gol',
        'penalty': 'Pênalti',
        'penaltySaved': 'Pênalti Defendido',
        'ownGoal': 'Gol Contra',
        'assist': 'Assistência',
        'statistics': 'Estatística  ',
        'noData': 'Não há dados',
        'notPrepared': 'O jogo não começa',
        // ======= end
        'prediction': 'Previsões para a partida',
        'vote': 'Voto',
        'voted': 'Votado',
        'home': 'Em Casa',
        'draw': 'Empate',
        'away': 'Fora',
        'voteNum': '(1 voto) | ({count} votos)',
        'voteFail': 'Falha ao enviar o voto. Por favor, tente novamente~',
        'matchVoted': 'Você já votou ~',
        'matchNotStart': 'O jogo não começa',
        'predictionEnd': 'O prazo para as previsões terminou. Lembre-se de enviar suas previsões antes do início da partida.',
        'statistic': 'Estatisticas',
        'past_games': 'Jogos passados',
        'pg_no': 'Nenhum Jogo Passado',
        'pg_lng': 'Últimos{count} Jogos',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Data',
        'pg_competition': 'Competição',
        'pg_home': 'Em Casa',
        'pg_result': 'Resultado',
        'pg_away': 'Fora',
        'absentee': 'Ausência',
        'absentee_no': 'Nenhuma ausência',
        'recent_games': 'Jogos Recentes',
        'rg_no': 'Nenhum Jogo Recente',
        'rg_date': 'Data',
        'rg_competition': 'Competição',
        'rg_home': 'Em Casa',
        'rg_result': 'Resultado',
        'rg_away': 'Fora',
        'league_table': 'Tabela da Liga',
        'lt_format': 'Formato',
        'lt_total': 'Total',
        'lt_home': 'Em Casa',
        'lt_away': 'Fora',
        'lt_p': 'J',
        'lt_w': 'V',
        'lt_d': 'E',
        'lt_l': 'D',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Ranking',
        'lt_wp': 'WP',
        'ct_team': 'Time',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Probabilidade',
        'odds_no': 'Nenhuma Probabilidade',
        'odds_no_data': 'Nenhum Dado',
        'odds_handicap': 'Lesões',
        'odds_ou': 'Acima/Sub',
        'odds_1x2': '1x2',
        'odds_over': 'Acima  ',
        'odds_under': 'Sub',
        'odds_total': 'Total',
        'odds_more': 'Mais',
        'odds_company': 'Empresa',
        'odds_type': 'Tip',
        'odds_spot': 'Ponto',
        'odds_initial': 'Inicial',
        'odds_home_win': 'Em Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Fora',
        'odds_tu': 'Tempo Atualizado',
        'odds_home_lose': 'Em Casa',
        'odds_draw': 'Empate',
        'odds_away_win': 'Fora',
        'odds_highest': 'Mais alto',
        'odds_lowest': 'Mais baixo',
        'odds_average': 'Média',
        'odds_changes': 'Alterações nas Probabilidades',
        'odds_dc': 'Alterações nos Detalhes',
        'more': 'mais',
        'broadcast': 'Informações da Transmissão',
        'Decimal': 'Decimal',
        'American': 'Americano',
        'Fractional': 'Fracional',
        'matchPredictionTip': 'Dicas para a Partida',
        'matchPredictionResult': 'Previsões de resultados pelas Dicas para a Partida',
        'matchPredictionView': 'Visualizar'
    },
    'it': {
        // overview
        // start =====
        'events': 'Eventi',
        'goal': 'Gol',
        'penalty': 'Rigore',
        'penaltySaved': 'Rigore Salvato',
        'ownGoal': 'Autogol',
        'assist': 'Assistenze',
        'statistics': 'Statistica',
        'noData': 'Nessun Dato',
        'notPrepared': 'Partita non cominciata',
        // ===== end
        'prediction': 'Sostieni Tua Squadra',
        'vote': 'Voti',
        'voted': 'Votato',
        'home': 'Casa',
        'draw': 'Pareggio',
        'away': 'Via',
        'voteNum': '(1 voto) | ({conteggio} voti)',
        'voteFail': 'Voto fallito, per favore provi~',
        'matchVoted': 'Hai già votato~',
        'matchNotStart': 'Partita non cominciata',
        'predictionEnd': 'Previsione è finita, ricordi di prevedere prima della partita',
        'statistic': 'Statistiche',
        'past_games': 'Partite Passate',
        'pg_no': 'Nessuna Partita Passata',
        'pg_lng': 'Ultimi {conteggio} Giochi',
        'pg_w': '{conteggio} W',
        'pg_d': '{conteggio} D',
        'pg_date': 'Dati',
        'pg_competition': 'Concorso',
        'pg_home': 'Casa',
        'pg_result': 'Risultato',
        'pg_away': 'Via',
        'absentee': 'Assente',
        'absentee_no': 'Nessun assente',
        'recent_games': 'Recenti Partite',
        'rg_no': 'Nessun Recente Partita',
        'rg_date': 'Data',
        'rg_competition': 'Concorso',
        'rg_home': 'Casa',
        'rg_result': 'Risultato',
        'rg_away': 'Via',
        'league_table': 'Classica a punti',
        'lt_format': 'Formato',
        'lt_total': 'Totale',
        'lt_home': 'Casa',
        'lt_away': 'Trasferta',
        'lt_p': 'G',
        'lt_w': 'V',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': 'S',
        'lt_pts': 'Pt',
        'lt_rank': 'Classifica',
        'lt_wp': 'VP',
        'ct_team': 'Squadra',
        'ct_p': 'G',
        'ct_w': 'V',
        'ct_d': 'N',
        'ct_l': 'P',
        'ct_fa': 'F/S',
        'ct_pts': 'Pt',
        'odds': 'Probabilità',
        'odds_no': 'Nessuna Probabilità',
        'odds_no_data': 'Nessun Dato',
        'odds_handicap': 'Disabile',
        'odds_ou': 'Sopra/Sotto',
        'odds_1x2': '1x2',
        'odds_over': 'Fine',
        'odds_under': 'Sopra',
        'odds_total': 'Sotto',
        'odds_more': 'Più',
        'odds_company': 'Società',
        'odds_type': 'Tipo',
        'odds_spot': 'Punto',
        'odds_initial': 'Iniziale',
        'odds_home_win': 'Casa',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Via',
        'odds_tu': 'Tempo aggiornato',
        'odds_home_lose': 'Casa',
        'odds_draw': 'Pareggio',
        'odds_away_win': 'Via',
        'odds_highest': 'Altissimo',
        'odds_lowest': 'Bassissimo',
        'odds_average': 'Media',
        'odds_changes': 'Cambiamenti Probabilità',
        'odds_dc': 'Cambiamenti Dettagli',
        'more': 'più',
        'broadcast': 'Info di trasmissione',
        'Decimal': 'Decimale',
        'American': 'Americano',
        'Fractional': 'Frazionale',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Risultati previsti da Match Tips',
        'matchPredictionView': 'Vista'
    },
    'fr': {
        // overview
        // start ======
        'events': 'Événements',
        'goal': 'Objectif',
        'penalty': 'Pénalité',
        'penaltySaved': 'Pénalité enregistrée',
        'ownGoal': ' Objectif propre',
        'assist': 'Assistez',
        'statistics': 'Statistique',
        'noData': 'Pas de données',
        'notPrepared': 'Le match ne commence pas',
        // ======= end
        'prediction': 'Soutenez votre équipe',
        'vote': 'Vote',
        'voted': 'Voté',
        'home': 'Domicile',
        'draw': 'Dessiner',
        'away': ' Invitée',
        'voteNum': '(1 vote) | ({count} votes)',
        'voteFail': 'Vote échoué, bien vouloir réessayer ~',
        'matchVoted': 'Vous avez déjà voté ~',
        'matchNotStart': 'Le match ne commence pas',
        'predictionEnd': 'La prédiction c\'est la fin, ne pas oublier de prédire avant le match',
        'statistic': 'Statistiques',
        'past_games': 'Jeux précédents',
        'pg_no': 'Aucun jeu précédent',
        'pg_lng': 'Derniers {count} Jeux',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Date',
        'pg_competition': 'Compétition',
        'pg_home': 'Domicile',
        'pg_result': 'Résultat',
        'pg_away': 'Invitée',
        'absentee': 'Absent',
        'absentee_no': 'Pas d\'absent',
        'recent_games': 'Jeux récents',
        'rg_no': 'Pas de jeux récents',
        'rg_date': 'Date',
        'rg_competition': 'Compétition',
        'rg_home': 'Domicile',
        'rg_result': 'Résultat',
        'rg_away': 'Invitée',
        'league_table': 'Table ligue',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Domicile',
        'lt_away': 'Invitée',
        'lt_p': 'J',
        'lt_w': 'G',
        'lt_d': 'N',
        'lt_l': 'P',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Équipe',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Chances',
        'odds_no': 'Aucune chance',
        'odds_no_data': 'Pas de données',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Au dessus de/En dessous de',
        'odds_1x2': '1x2',
        'odds_over': 'Au dessus de',
        'odds_under': 'En dessous de',
        'odds_total': 'Total',
        'odds_more': 'Plus',
        'odds_company': 'Compagnie',
        'odds_type': 'Type',
        'odds_spot': 'Place',
        'odds_initial': 'Initial',
        'odds_home_win': 'Domicile',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Invitée',
        'odds_tu': 'Heure mise à jour',
        'odds_home_lose': 'Domicile',
        'odds_draw': 'Dessiner',
        'odds_away_win': 'Invitée',
        'odds_highest': 'Le plus élevé',
        'odds_lowest': 'Le plus bas',
        'odds_average': 'Moyenne',
        'odds_changes': 'Modifications de cotes',
        'odds_dc': 'Modifications de détail',
        'more': 'plus',
        'broadcast': 'Infos diffusion',
        'Decimal': 'Décimal',
        'American': 'Américain',
        'Fractional': 'Fractionnaire',
        'matchPredictionTip': 'Match Tips',
        'matchPredictionResult': 'Résultats prévus par Match Tips',
        'matchPredictionView': 'Vue'
    },
    'ru': {
        // overview
        // start =====
        'events': 'Мероприятия',
        'goal': 'Цель',
        'penalty': 'Пенальти',
        'penaltySaved': 'Отбитый Пенальти',
        'ownGoal': 'Автогол',
        'assist': 'голевые передачи',
        'statistics': 'Статистика',
        'noData': 'Нет данных',
        'notPrepared': 'Матч не начат',
        // ===== end
        'prediction': 'Поддержите вашу команду',
        'vote': 'Голосовать',
        'voted': 'проголосовавший',
        'home': 'Домашний',
        'draw': 'рисовать',
        'away': 'потерять',
        'voteNum': '(1 голос) | ({count} голосов)',
        'voteFail': 'Проголосовать не удалось, повторите попытку ~',
        'matchVoted': 'Вы уже голосовали ~',
        'matchNotStart': 'Матч не начат',
        'predictionEnd': 'Прогнозирование окончено, не забудьте предсказать перед матчем',
        'statistic': 'Статистика',
        'past_games': 'Прошедшие игры',
        'pg_no': 'Нет прошлых игр',
        'pg_lng': 'Последние {count} игры',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Дата',
        'pg_competition': 'Соревнование',
        'pg_home': 'Домашний',
        'pg_result': 'результат',
        'pg_away': 'потерять',
        'absentee': 'отсутствующий',
        'absentee_no': 'Нет отсутствующих',
        'recent_games': 'Недавние игры',
        'rg_no': 'Нет недавних игр',
        'rg_date': 'Дата',
        'rg_competition': 'Соревнование',
        'rg_home': 'Домашний',
        'rg_result': 'Результат',
        'rg_away': 'потерять',
        'league_table': 'Таблица Лиги',
        'lt_format': 'Формат',
        'lt_total': 'Всего',
        'lt_home': 'Домашний',
        'lt_away': 'потерять',
        'lt_p': 'И',
        'lt_w': 'В',
        'lt_d': 'Н',
        'lt_l': 'П',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Очки',
        'lt_rank': 'Разряд',
        'lt_wp': 'WP',
        'ct_team': 'Команда',
        'ct_p': 'И',
        'ct_w': 'В',
        'ct_d': 'Н',
        'ct_l': 'П',
        'ct_fa': 'F/A',
        'ct_pts': 'ОЧКИ',
        'odds': 'Вероятность выигрыша',
        'odds_no': 'Нет вероятности выигрыша',
        'odds_no_data': 'Нет данных',
        'odds_handicap': 'Фора',
        'odds_ou': 'Больше / Меньше',
        'odds_1x2': '1х2',
        'odds_over': 'Больше',
        'odds_under': 'Меньше',
        'odds_total': 'Всего',
        'odds_more': 'Еще',
        'odds_company': 'Компания',
        'odds_type': 'Тип',
        'odds_spot': 'Одиннадцатиметровая отметка',
        'odds_initial': 'Начальный',
        'odds_home_win': 'Домашний',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'потерять',
        'odds_tu': 'Время обновлено',
        'odds_home_lose': 'Домашний',
        'odds_draw': 'постановочный бросок',
        'odds_away_win': 'потерять',
        'odds_highest': 'Наибольший',
        'odds_lowest': 'Низший',
        'odds_average': 'Средний',
        'odds_changes': 'Изменения вероятности выигрыша',
        'odds_dc': 'Изменения Деталей',
        'more': 'еще',
        'broadcast': 'Информация о трансляции',
        'Decimal': 'Десятичная дробь',
        'American': 'Американский',
        'Fractional': 'Дробный',
        'matchPredictionTip': 'Советы по игре',
        'matchPredictionResult': 'Прогнозируемые результаты от Советов по игре',
        'matchPredictionView': 'Посмотреть'
    },
    'tr': {
        'prediction': 'Maç Tahmini',
        'vote': 'Oy',
        'voted': 'oy',
        'home': 'birincil',
        'draw': 'çizmek',
        'away': 'yolcu',
        'voteNum': '(1 oy) | ({count} oy)',
        'voteFail': 'Oy veremedi, lütfen tekrar deneyin ~',
        'matchVoted': 'Zaten oy kullandın ~',
        'matchNotStart': 'Maç başlamıyor',
        'predictionEnd': 'Tahmin son, maçtan önce tahmin etmeyi unutmayın'
    },
    'in': {
        'prediction': 'Prediksi Pertandingani',
        'vote': 'Memilih',
        'voted': 'Terpilih',
        'home': 'Tuhan',
        'draw': 'Draw',
        'away': 'Tamu',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Vote gagal, mohon dicoba ~',
        'matchVoted': 'Kamu sudah memilih ~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi sudah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'past_games': 'Pertandingan Terakhir',
        'pg_no': 'Tidak Ada Pertandingan Terakhir',
        'pg_lng': 'Pertandingan {count} Terakhir',
        'pg_w': 'M',
        'pg_d': 'H',
        'pg_date': 'Tanggal',
        'pg_competition': 'Persaingan',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Pemain yang Tidak Hadir',
        'absentee_no': 'No Pemain yang Tidak Hadir',
        'recent_games': 'Pertandingan Terkini',
        'rg_no': 'Tidak Ada Pertandingan Terkini',
        'rg_date': 'Tanggal',
        'rg_competition': 'Persaingan',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Klasemen Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Poin',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Poin',
        'odds': 'Odd',
        'odds_no': 'Tidak Ada Odd',
        'odds_no_data': 'Tidak Ada Data',
        'odds_handicap': 'Handicap',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih Lanjut',
        'odds_company': 'Perusahaan',
        'odds_type': 'Jenis',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu yang Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Penarikan',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Tertinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Odd',
        'odds_dc': 'Perubahan Detail',
        'more': 'lebih lanjut'
    },
    'th': {
        // overview
        // start ======
        'events': 'เหตุการณ์',
        'goal': 'ประตู',
        'penalty': 'ลูกโทษ',
        'penaltySaved': 'ลูกโทษที่ถูกป้องกัน',
        'ownGoal': 'การทำเข้าประตูตัวเอง',
        'assist': 'การจ่ายบอลแล้วเป็นประตู',
        'statistics': 'สถิติ',
        'noData': 'ไม่มีข้อมูล',
        'notPrepared': 'การแข่งขันยังไม่เริ่มต้น',
        // ===== end
        'prediction': 'สนับสนุนทีมของคุณ',
        'vote': 'โหวต',
        'voted': 'โหวตแล้ว',
        'home': 'เจ้าบ้าน',
        'draw': 'เสมอ',
        'away': 'ทีมเยือน',
        'voteNum': '(1 โหวต) | ({count} โหวต)',
        'voteFail': 'การโหวตล้มเหลว โปรดลองอีกครั้ง ~',
        'matchVoted': 'คุณได้โหวตเรียบร้อยแล้ว ~',
        'matchNotStart': 'การแข่งขันยังไม่เริ่มต้น',
        'predictionEnd': 'การทำนายสิ้นสุดแล้ว อย่าลืมทำนายก่อนการแข่งขัน',
        'statistic': 'สถิติ',
        'broadcast': 'ข้อมูลการออกอากาศ',
        'past_games': 'เกมที่ผ่านมา',
        'pg_no': 'ไม่มีเกมที่ผ่านมา',
        'pg_lng': '{count} เกมล่าสุด',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'วันที่',
        'pg_competition': 'การแข่งขัน',
        'pg_home': 'เจ้าบ้าน',
        'pg_result': 'ผลการแข่งขัน',
        'pg_away': 'ทีมเยือน',
        'absentee': 'ผู้ที่ไม่มา',
        'absentee_no': 'ไม่มีผู้ที่ไม่มา',
        'recent_games': 'เกมล่าสุด',
        'rg_no': 'ไม่มีเกมล่าสุด',
        'rg_date': 'วันที่',
        'rg_competition': 'การแข่งขัน',
        'rg_home': 'เจ้าบ้าน',
        'rg_result': 'ผลการแข่งขัน',
        'rg_away': 'ทีมเยือน',
        'league_table': 'ตารางลีก',
        'lt_format': 'รูปแบบ',
        'lt_total': 'รวม',
        'lt_home': 'เจ้าบ้าน',
        'lt_away': 'ทีมเยือน',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'อันดับ',
        'lt_wp': 'WP',
        'ct_team': 'ทีม',
        'ct_p': 'แข่ง',
        'ct_w': 'ชนะ',
        'ct_d': 'เสมอ',
        'ct_l': 'แพ้',
        'ct_fa': 'F/A',
        'ct_pts': 'คะแนน',
        'odds': 'ราคาต่อรอง',
        'odds_no': 'ไม่มีราคาต่อรอง',
        'odds_no_data': 'ไม่มีข้อมูล',
        'odds_handicap': 'แฮนดิแคป',
        'odds_ou': 'สูง/ต่ำ',
        'odds_1x2': '1x2',
        'odds_over': 'สูง',
        'odds_under': 'ต่ำ',
        'odds_total': 'รวม',
        'odds_more': 'เพิ่มเติม',
        'odds_company': 'บริษัท',
        'odds_type': 'ชนิด',
        'odds_spot': 'จุด',
        'odds_initial': 'เริ่มต้น',
        'odds_home_win': 'เจ้าบ้าน',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'ทีมเยือน',
        'odds_tu': 'อัปเดตเวลาแล้ว',
        'odds_home_lose': 'เจ้าบ้าน',
        'odds_draw': 'เสมอ',
        'odds_away_win': 'ทีมเยือน',
        'odds_highest': 'สูงสุด',
        'odds_lowest': 'ต่ำสุด',
        'odds_average': 'ค่าเฉลี่ย',
        'odds_changes': 'การเปลี่ยนแปลงราคาต่อรอง',
        'odds_dc': 'การเปลี่ยนแปลงรายละเอียด',
        'Decimal': 'ทศนิยม',
        'American': 'อเมริกัน',
        'Fractional': 'เป็นเศษส่วน',
        'more': 'เพิ่มเติม',
        'matchPredictionTip': 'เทคนิคในการแข่งขัน (Match Tips)',
        'matchPredictionResult': 'ผลลัพธ์ที่คาดการณ์โดย เทคนิคในการแข่งขัน',
        'matchPredictionView': 'ดู'
    },
    'de': {
        // overview
        // start ======
        'events': 'Veranstaltungen',
        'goal': 'Tor',
        'penalty': 'Elfmeter',
        'penaltySaved': 'Strafe gespeichert',
        'ownGoal': 'Eigentor',
        'assist': 'Helfen',
        'statistics': 'Statistik',
        'noData': 'Keine Daten',
        'notPrepared': 'Das Match beginnt nicht',
        // ====== end
        'prediction': 'Unterstütze dein Team',
        'vote': 'Abstimmung',
        'voted': 'Abgestimmt',
        'home': 'Zuhause',
        'draw': 'Unentschieden',
        'away': 'Nicht anwesend',
        'voteNum': '(1 Stimme) | ({count} Stimmen)',
        'voteFail': 'Abstimmung fehlgeschlagen, bitte wiederholen ~',
        'matchVoted': 'Du hast bereits abgestimmt~',
        'matchNotStart': 'Das Match beginnt nicht',
        'predictionEnd': 'Vorhersage ist beendet, denke daran, vor dem Spiel vorherzusagen',
        'statistic': 'Statistiken',
        'broadcast': 'Info senden',
        'past_games': 'Vorherige Spiele',
        'pg_no': 'Keine vorherigen Spiele',
        'pg_lng': 'Letzte {count} Spiele',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Datum',
        'pg_competition': 'Wettbewerb',
        'pg_home': 'Zuhause',
        'pg_result': 'Ergebnis',
        'pg_away': 'Nicht anwesend',
        'absentee': 'Abwesenheit',
        'absentee_no': 'Kein Abwesender',
        'recent_games': 'Neueste Spiele',
        'rg_no': 'Keine neuesten Spiele',
        'rg_date': 'Datum',
        'rg_competition': 'Wettbewerb',
        'rg_home': 'Zuhause',
        'rg_result': 'Ergebnis',
        'rg_away': 'Nicht anwesend',
        'league_table': 'Ligatabelle',
        'lt_format': 'Format',
        'lt_total': 'Gesamt',
        'lt_home': 'Zuhause',
        'lt_away': 'Nicht anwesend',
        'lt_p': 'P',
        'lt_w': 'W',
        'lt_d': 'D',
        'lt_l': 'L',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pkte',
        'lt_rank': 'Rang',
        'lt_wp': 'WP',
        'ct_team': 'Mannschaft',
        'ct_p': 'Sp',
        'ct_w': 'G',
        'ct_d': 'U',
        'ct_l': 'V',
        'ct_fa': 'F/A',
        'ct_pts': 'Pkt',
        'odds': 'Chancen',
        'odds_no': 'Keine Chancen',
        'odds_no_data': 'Keine Daten',
        'odds_handicap': 'Behinderung',
        'odds_ou': 'Über/Unter',
        'odds_1x2': '1x2',
        'odds_over': 'Über',
        'odds_under': 'Unter',
        'odds_total': 'Gesamt',
        'odds_more': 'Mehr',
        'odds_company': 'Unternehmen',
        'odds_type': 'Art',
        'odds_spot': 'Stelle',
        'odds_initial': 'Start',
        'odds_home_win': 'Zuhause',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Nicht anwesend',
        'odds_tu': 'Zeit aktualisiert',
        'odds_home_lose': 'Zuhause',
        'odds_draw': 'Unentschieden',
        'odds_away_win': 'Nicht anwesend',
        'odds_highest': 'Höchste',
        'odds_lowest': 'Niedrigste',
        'odds_average': 'Durchschnittliche',
        'odds_changes': 'Quotenänderungen',
        'odds_dc': 'Detailänderungen',
        'Decimal': 'Dezimal',
        'American': 'Amerikanisch',
        'Fractional': 'Fraktional',
        'more': 'mehr',
        'matchPredictionTip': 'Spieltipps',
        'matchPredictionResult': 'Voraussichtliche Ergebnisse gemäss Spieltipps',
        'matchPredictionView': 'Aussicht'
    },
    'id': {
        // overview
        // start ======
        'events': 'Acara',
        'goal': 'Gol',
        'penalty': 'Penalti',
        'penaltySaved': 'Penyelamatan Tendangan Penalti',
        'ownGoal': 'Gol Bunuh Diri',
        'assist': 'Umpan',
        'statistics': 'Statistik',
        'noData': 'Tidak Ada Data',
        'notPrepared': 'Pertandingan tidak dimulai',
        // ===== end
        'prediction': 'Dukung Tim Anda',
        'vote': 'Memilih',
        'voted': 'Dipilih',
        'home': 'Kandang',
        'draw': 'Seri',
        'away': 'Tandang',
        'voteNum': '(1 suara) | ({count} suara)',
        'voteFail': 'Pemungutan suara gagal, coba lagi~',
        'matchVoted': 'Anda telah memilih~',
        'matchNotStart': 'Pertandingan tidak dimulai',
        'predictionEnd': 'Prediksi telah berakhir, ingatlah untuk memprediksi sebelum pertandingan',
        'statistic': 'Statistik',
        'broadcast': 'Info Siaran',
        'past_games': 'Permainan yang Lalu',
        'pg_no': 'Tidak ada Permainan yang Lalu',
        'pg_lng': 'Pertandingan {count} yang Terakhir',
        'pg_w': '{count} W',
        'pg_d': '{count} D',
        'pg_date': 'Tanggal',
        'pg_competition': 'Kompetisi',
        'pg_home': 'Kandang',
        'pg_result': 'Hasil',
        'pg_away': 'Tandang',
        'absentee': 'Absen',
        'absentee_no': 'Tidak Absen',
        'recent_games': 'Game Terbaru',
        'rg_no': 'Tidak ada permainan terbaru',
        'rg_date': 'Tanggal',
        'rg_competition': 'Kompetisi',
        'rg_home': 'Kandang',
        'rg_result': 'Hasil',
        'rg_away': 'Tandang',
        'league_table': 'Tabel Liga',
        'lt_format': 'Format',
        'lt_total': 'Total',
        'lt_home': 'Kandang',
        'lt_away': 'Tandang',
        'lt_p': 'P',
        'lt_w': 'M',
        'lt_d': 'S',
        'lt_l': 'K',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': 'Pts',
        'lt_rank': 'Peringkat',
        'lt_wp': 'WP',
        'ct_team': 'Tim',
        'ct_p': 'P',
        'ct_w': 'W',
        'ct_d': 'D',
        'ct_l': 'L',
        'ct_fa': 'F/A',
        'ct_pts': 'Pts',
        'odds': 'Tolak ukur kekuatan tim',
        'odds_no': 'Tidak ada tolak ukur kekuatan tim',
        'odds_no_data': 'Tidak ada data',
        'odds_handicap': 'Keunggulan',
        'odds_ou': 'Atas/Bawah',
        'odds_1x2': '1x2',
        'odds_over': 'Atas',
        'odds_under': 'Bawah',
        'odds_total': 'Total',
        'odds_more': 'Lebih',
        'odds_company': 'Perusahaan',
        'odds_type': 'Tipe',
        'odds_spot': 'Titik',
        'odds_initial': 'Awal',
        'odds_home_win': 'Kandang',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Tandang',
        'odds_tu': 'Waktu Diperbarui',
        'odds_home_lose': 'Kandang',
        'odds_draw': 'Seri',
        'odds_away_win': 'Tandang',
        'odds_highest': 'Paling tinggi',
        'odds_lowest': 'Terendah',
        'odds_average': 'Rata-rata',
        'odds_changes': 'Perubahan Tolak ukur kekuatan tim',
        'odds_dc': 'Perubahan Detail',
        'Decimal': 'Desimal',
        'American': 'Amerika',
        'Fractional': 'Pecahan',
        'more': 'lebih',
        'matchPredictionTip': 'Tips Pertandingan',
        'matchPredictionResult': 'Prediksi hasil dengan Tips Pertandingan',
        'matchPredictionView': 'Tampilan'
    },
    'ja': {
        // overview
        // start =====
        'events': 'イベント',
        'goal': 'ゴール',
        'penalty': 'ペナルティ',
        'penaltySaved': '保存されたパンルティ',
        'ownGoal': '自らの目標',
        'assist': 'アシスト',
        'statistics': '統計',
        'noData': 'データありません',
        'notPrepared': '試合は開始していません。',
        // ===== end
        'prediction': 'お客様のチームをサポートします。',
        'vote': '投票',
        'voted': '投票しました。',
        'home': 'ホーム',
        'draw': '描く',
        'away': 'アウェイ',
        'voteNum': '（１回投票）) | ({count} 投票)',
        'voteFail': '投票失敗しました。再度お試しください～',
        'matchVoted': '既に投票済でした。',
        'matchNotStart': '試合は開始していません。',
        'predictionEnd': '予測は終了しました。試合の前に予測するようにご注意ください。',
        'statistic': '統計',
        'broadcast': '放送情報',
        'past_games': '過去ゲーム',
        'pg_no': '過去ゲームがありません。',
        'pg_lng': '過去 {count}ゲーム',
        'pg_w': '{count}W',
        'pg_d': '{count}D',
        'pg_date': '期日',
        'pg_competition': '対戦',
        'pg_home': 'ホーム',
        'pg_result': '結果',
        'pg_away': 'アウェイ',
        'absentee': '欠席',
        'absentee_no': '欠席なし',
        'recent_games': '最近のゲーム',
        'rg_no': '最近のゲームがありません',
        'rg_date': '期日',
        'rg_competition': '対戦',
        'rg_home': 'ホーム',
        'rg_result': '結果',
        'rg_away': 'アウェイ',
        'league_table': '順位表',
        'lt_format': 'フォーマット',
        'lt_total': 'トータル',
        'lt_home': 'ホーム',
        'lt_away': 'アウェイ',
        'lt_p': '試',
        'lt_w': '勝',
        'lt_d': '分',
        'lt_l': '負',
        'lt_f': '+',
        'lt_a': '-',
        'lt_pts': '勝点',
        'lt_rank': 'ランキング',
        'lt_wp': 'WP',
        'ct_team': 'チーム',
        'ct_p': '試',
        'ct_w': '勝',
        'ct_d': '分',
        'ct_l': '負',
        'ct_fa': 'F/A',
        'ct_pts': '勝点',
        'odds': '勝目',
        'odds_no': '勝目がありません',
        'odds_no_data': 'データがありません',
        'odds_handicap': 'ハンディキャップ',
        'odds_ou': '以上/以下',
        'odds_1x2': '1x2',
        'odds_over': '以上',
        'odds_under': '以下',
        'odds_total': 'トータル',
        'odds_more': 'より多く',
        'odds_company': '会社',
        'odds_type': 'タイプ',
        'odds_spot': 'スポット',
        'odds_initial': 'イニシャル',
        'odds_home_win': 'ホーム',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'アウェイ',
        'odds_tu': '更新された時間',
        'odds_home_lose': 'ホーム',
        'odds_draw': '描く',
        'odds_away_win': 'アウェイ',
        'odds_highest': '一番高い',
        'odds_lowest': '一番低い',
        'odds_average': '平均',
        'odds_changes': '確率の変化',
        'odds_dc': '詳細変更内容',
        'Decimal': '１０進数',
        'American': 'アメリカ',
        'Fractional': '分数',
        'more': 'より多く',
        'matchPredictionTip': '試合のヒント',
        'matchPredictionResult': '試合ヒントによる予測結果',
        'matchPredictionView': 'ビューア'
    },
    'vi': {
        // overview
        // start =====
        'events': 'Sự kiện',
        'goal': 'Bàn thắng',
        'penalty': 'Phạt đền',
        'penaltySaved': 'Pha cứu thua phạt đền',
        'ownGoal': 'Bàn thắng riêng',
        'assist': 'Hỗ trợ',
        'statistics': 'Số liệu thống kê',
        'noData': 'Không có dữ liệu',
        'notPrepared': 'Trận đấu chưa bắt đầu',
        // ===== end
        'prediction': 'Ủng hộ đội của bạn',
        'vote': 'Bầu chọn',
        'voted': 'Đã bầu chọn',
        'home': 'Sân nhà',
        'draw': 'Hòa',
        'away': 'Sân khách',
        'voteNum': '(1 bầu chọn) | ({count} bầu chọn)',
        'voteFail': 'Bầu chọn không thành công, vui lòng thử lại~',
        'matchVoted': 'Bạn đã bầu chọn~',
        'matchNotStart': 'Trận đấu chưa bắt đầu',
        'predictionEnd': 'Kết thúc dự đoán, hãy nhớ dự đoán trước trận đấu',
        'statistic': 'Số liệu thống kê',
        'broadcast': 'Thông tin Phát sóng',
        'past_games': 'Các Trận đấu trước',
        'pg_no': 'Không có trận đấu trước',
        'pg_lng': 'Những trận {count} gần nhất',
        'pg_w': '{count} T.',
        'pg_d': '{count} H.',
        'pg_date': 'Ngày',
        'pg_competition': 'Cuộc thi đấu',
        'pg_home': 'Sân nhà',
        'pg_result': 'Kết quả',
        'pg_away': 'Sân khách',
        'absentee': 'Người vắng mặt',
        'absentee_no': 'Không có người vắng mặt',
        'recent_games': 'Những trận đấu gần đây',
        'rg_no': 'Không có trận đấu gần đây',
        'rg_date': 'Ngày',
        'rg_competition': 'Cuộc thi đấu',
        'rg_home': 'Sân nhà',
        'rg_result': 'Kết quả',
        'rg_away': 'Sân khách',
        'league_table': 'Bảng Vị trí Thi đấu',
        'lt_format': 'Định dạng',
        'lt_total': 'Tổng ',
        'lt_home': 'Sân nhà',
        'lt_away': 'Sân khách',
        'lt_p': 'S.T.',
        'lt_w': 'T.',
        'lt_d': 'H.',
        'lt_l': 'B',
        'lt_f': 'B.Tg.',
        'lt_a': 'B.Th.',
        'lt_pts': 'Đ.',
        'lt_rank': 'Xếp hạng',
        'lt_wp': 'WP',
        'ct_team': 'Đội',
        'ct_p': 'S.T.',
        'ct_w': 'T.',
        'ct_d': 'H.',
        'ct_l': 'B.',
        'ct_fa': 'F/A',
        'ct_pts': 'Đ.',
        'odds': 'Lợi thế',
        'odds_no': 'Không có lợi thế',
        'odds_no_data': 'Không có dữ liệu',
        'odds_handicap': 'Bất lợi',
        'odds_ou': 'Trên/Dưới',
        'odds_1x2': '1x2',
        'odds_over': 'Trên',
        'odds_under': 'Dưới',
        'odds_total': 'Tổng',
        'odds_more': 'Hơn',
        'odds_company': 'Công ty',
        'odds_type': 'Loại',
        'odds_spot': 'Điểm',
        'odds_initial': 'Ban đầu',
        'odds_home_win': 'Sân nhà',
        'odds_hdp': 'HDP',
        'odds_away_lose': 'Sân khách',
        'odds_tu': 'Thời gian cập nhật',
        'odds_home_lose': 'Sân nhà',
        'odds_draw': 'Hòa',
        'odds_away_win': 'Sân khách',
        'odds_highest': 'Cao nhất',
        'odds_lowest': 'Thấp nhất',
        'odds_average': 'Trung bình',
        'odds_changes': 'Thay đổi lợi thế',
        'odds_dc': 'Chi tiết thay đổi',
        'Decimal': 'Phần thập phân',
        'American': 'Người Mỹ',
        'Fractional': 'Phân số',
        'more': 'hơn',
        'matchPredictionTip': 'Thủ thuật trận đấu',
        'matchPredictionResult': 'Kết quả dự đoán theo thủ thuật trận đấu',
        'matchPredictionView': 'Xem'
    },
    'ar': {
        // overview
        // start =====
        'events': 'فعاليات',
        'goal': 'هدف',
        'penalty': 'ركلة جزاء',
        'penaltySaved': 'ركلة جزاء مصدودة',
        'ownGoal': 'هدف عكسي',
        'assist': 'صناعة هدف',
        'statistics': 'إحصائيات',
        'noData': 'لا توجد بيانات',
        'notPrepared': 'المباراة لم تبدأ',
        // ===== end
        'prediction': 'ادعم فريقك',
        'vote': 'تصويت',
        'voted': 'تم التصويت',
        'home': 'على ملعبه',
        'draw': 'تعادل',
        'away': 'خارج ملعبه',
        'voteNum': '(1 صوت) | ({count} أصوات)',
        'voteFail': 'فشل التصويت، يُرجى إعادة المحاولة~',
        'matchVoted': 'قمت بالتصويت بالفعل~',
        'matchNotStart': 'المباراة لم تبدأ',
        'predictionEnd': 'انتهت فترة التوقع، تذكر أن تقدم توقعك قبل المباراة',
        'statistic': 'إحصائيات',
        'broadcast': 'معلومات البث',
        'past_games': 'مباريات سابقة',
        'pg_no': 'لا توجد مباريات سابقة',
        'pg_lng': 'آخر {count} مباراة',
        'pg_w': '{count} فوز',
        'pg_d': '{count} تعادل',
        'pg_date': 'تاريخ',
        'pg_competition': 'منافسة',
        'pg_home': 'على ملعبه',
        'pg_result': 'نتيجة',
        'pg_away': 'خارج ملعبه',
        'absentee': 'غيابات',
        'absentee_no': 'لا توجد غيابات',
        'recent_games': 'المباريات الحالية',
        'rg_no': ' توجد مباريات حالية',
        'rg_date': 'تاريخ',
        'rg_competition': 'منافسة',
        'rg_home': 'على ملعبه',
        'rg_result': 'نتيجة',
        'rg_away': 'خارج ملعبه',
        'league_table': 'جدول الدوري',
        'lt_format': 'التشكيل',
        'lt_total': 'إجمالي',
        'lt_home': 'على ملعبه',
        'lt_away': 'خارج ملعبه',
        'lt_p': 'لعب',
        'lt_w': 'فوز',
        'lt_d': 'تعادل',
        'lt_l': 'هزيمة',
        'lt_f': 'أهداف له',
        'lt_a': 'أهداف عليه',
        'lt_pts': 'النقاط',
        'lt_rank': 'التصنيف',
        'lt_wp': 'النقاط المحصَّلة',
        'ct_team': 'الفريق',
        'ct_p': 'لعب',
        'ct_w': 'فوز',
        'ct_d': 'تعادل',
        'ct_l': 'هزيمة',
        'ct_fa': 'أهداف له/أهداف عليه',
        'ct_pts': 'النقاط',
        'odds': 'احتمالات',
        'odds_no': 'لا توجد احتمالات',
        'odds_no_data': 'لا توجد بيانات',
        'odds_handicap': 'هانديكاب',
        'odds_ou': 'أكثر/أقل',
        'odds_1x2': '1x2',
        'odds_over': 'أكثر',
        'odds_under': 'أقل',
        'odds_total': 'إجمالي',
        'odds_more': 'المزيد',
        'odds_company': 'شركة',
        'odds_type': 'نوع',
        'odds_spot': 'نقطة اللعب',
        'odds_initial': 'أولي',
        'odds_home_win': 'على ملعبه',
        'odds_hdp': 'هانديكاب',
        'odds_away_lose': 'خارج ملعبه',
        'odds_tu': 'تحديث الوقت',
        'odds_home_lose': 'على ملعبه',
        'odds_draw': 'تعادل',
        'odds_away_win': 'خارج ملعبه',
        'odds_highest': 'أعلى',
        'odds_lowest': 'أدنى',
        'odds_average': 'متوسط',
        'odds_changes': 'تغييرات الاحتمالات',
        'odds_dc': 'تغييرات التفاصيل',
        'Decimal': 'رقم عشري',
        'American': 'أمريكي',
        'Fractional': 'رقم كسري',
        'more': 'المزيد',
        'matchPredictionTip': 'نصائح المباراة',
        'matchPredictionResult': 'النتائج المتوقعة من خلال نصائح المباراة',
        'matchPredictionView': 'عرض'
    }
};



// WEBPACK FOOTER //
// ./src/lang/matchDetail.js